<template>
  <div class="loading" :class="isAni ? 'loading-ani' : ''" v-if="isShow.isLDShow">
    <div class="ld-animation">
      <div class="ld-person"></div>
    </div>
    <div class="progress-bar-wp">
      <div class="progress-bar">
        <div class="progress-bar-inner" :style="`width: ${loadingNum}%;`"></div>
      </div>
      <div class="progress-text">{{loadingNum}}%</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: Object
  },
  data () {
    return {
      isAni: false,
      loadingNum: 0,
      imgArr: [],
      preLoadImg: [{"src":require('../../pages/loading/img/ld-bg.jpg')},{"src":require('../../pages/loading/img/ld-person.png')},{"src":require('../../pages/page-five/img/h5-1.png')},{"src":require('../../pages/page-five/img/h5-2.png')},{"src":require('../../pages/page-five/img/pg5-arrow-left.png')},{"src":require('../../pages/page-five/img/pg5-arrow-right.png')},{"src":require('../../pages/page-five/img/pg5-article-bg.png')},{"src":require('../../pages/page-five/img/pg5-article-text1.png')},{"src":require('../../pages/page-five/img/pg5-article-text2.png')},{"src":require('../../pages/page-five/img/pg5-article-text3.png')},{"src":require('../../pages/page-five/img/pg5-article-text4.png')},{"src":require('../../pages/page-five/img/pg5-article-title1-inner.png')},{"src":require('../../pages/page-five/img/pg5-article-title2-inner.png')},{"src":require('../../pages/page-five/img/pg5-article2-bg.png')},{"src":require('../../pages/page-five/img/pg5-article2-text1.png')},{"src":require('../../pages/page-five/img/pg5-article2-text2.png')},{"src":require('../../pages/page-five/img/pg5-article2-text3.png')},{"src":require('../../pages/page-five/img/pg5-fig1-table.png')},{"src":require('../../pages/page-five/img/pg5-fig1.png')},{"src":require('../../pages/page-five/img/pg5-fig2-table.png')},{"src":require('../../pages/page-five/img/pg5-fig2.png')},{"src":require('../../pages/page-five/img/pg5-fig3-bottom.png')},{"src":require('../../pages/page-five/img/pg5-fig3-table.png')},{"src":require('../../pages/page-five/img/pg5-fig3.png')},{"src":require('../../pages/page-five/img/pg5-inner-title.png')},{"src":require('../../pages/page-five/img/pg5-left1.png')},{"src":require('../../pages/page-five/img/pg5-left2.png')},{"src":require('../../pages/page-five/img/pg5-left3.png')},{"src":require('../../pages/page-five/img/pg5-mid1.png')},{"src":require('../../pages/page-five/img/pg5-mid2.png')},{"src":require('../../pages/page-five/img/pg5-mid3.png')},{"src":require('../../pages/page-five/img/pg5-mid4.png')},{"src":require('../../pages/page-five/img/pg5-mid5.png')},{"src":require('../../pages/page-five/img/pg5-mid6.png')},{"src":require('../../pages/page-five/img/pg5-right1.png')},{"src":require('../../pages/page-five/img/pg5-right2.png')},{"src":require('../../pages/page-five/img/pg5-right3.png')},{"src":require('../../pages/page-five/img/pg5-title.png')},{"src":require('../../pages/page-four/img/pg4-article-text1.png')},{"src":require('../../pages/page-four/img/pg4-article-text2.png')},{"src":require('../../pages/page-four/img/pg4-article-text3.png')},{"src":require('../../pages/page-four/img/pg4-article-title1-inner.png')},{"src":require('../../pages/page-four/img/pg4-article-title2-inner.png')},{"src":require('../../pages/page-four/img/pg4-article-title3-inner.png')},{"src":require('../../pages/page-four/img/pg4-article-title4-inner.png')},{"src":require('../../pages/page-four/img/pg4-article1-bg.png')},{"src":require('../../pages/page-four/img/pg4-article2-c1.png')},{"src":require('../../pages/page-four/img/pg4-article2-c2.png')},{"src":require('../../pages/page-four/img/pg4-article2-c3.png')},{"src":require('../../pages/page-four/img/pg4-article2-c4.png')},{"src":require('../../pages/page-four/img/pg4-article2.png')},{"src":require('../../pages/page-four/img/pg4-article3-bg.png')},{"src":require('../../pages/page-four/img/pg4-article3-h1.png')},{"src":require('../../pages/page-four/img/pg4-article3-h2.png')},{"src":require('../../pages/page-four/img/pg4-article3-h3.png')},{"src":require('../../pages/page-four/img/pg4-article3-h4.png')},{"src":require('../../pages/page-four/img/pg4-article3-h5.png')},{"src":require('../../pages/page-four/img/pg4-article3-h6.png')},{"src":require('../../pages/page-four/img/pg4-article4-bg.png')},{"src":require('../../pages/page-four/img/pg4-article4-text1.png')},{"src":require('../../pages/page-four/img/pg4-bottom-bg.png')},{"src":require('../../pages/page-four/img/pg4-title.png')},{"src":require('../../pages/page-four/img/sprite.png')},{"src":require('../../pages/page-kv/img/kv-bg.jpg')},{"src":require('../../pages/page-kv/img/kv-ring.png')},{"src":require('../../pages/page-kv/img/kv-start.png')},{"src":require('../../pages/page-kv/img/kv-sub-title.png')},{"src":require('../../pages/page-kv/img/kv-txt1.png')},{"src":require('../../pages/page-kv/img/kv-txt2.png')},{"src":require('../../pages/page-kv/img/kv-txt3.png')},{"src":require('../../pages/page-kv/img/kv-txt4.png')},{"src":require('../../pages/page-kv/img/kv-year.png')},{"src":require('../../pages/page-one/img/p1-c1-p1.jpg')},{"src":require('../../pages/page-one/img/p1-c1-p2.jpg')},{"src":require('../../pages/page-one/img/p1-c1-p3.jpg')},{"src":require('../../pages/page-one/img/p1-c1-p4.jpg')},{"src":require('../../pages/page-one/img/p1-c2-p1.jpg')},{"src":require('../../pages/page-one/img/p1-c2-p2.jpg')},{"src":require('../../pages/page-one/img/p1-c2-p3.jpg')},{"src":require('../../pages/page-one/img/p1-c2-p4.jpg')},{"src":require('../../pages/page-one/img/p1-c3-p1.jpg')},{"src":require('../../pages/page-one/img/p1-c3-p2.jpg')},{"src":require('../../pages/page-one/img/p1-c3-p3.jpg')},{"src":require('../../pages/page-one/img/p1-c3-p4.jpg')},{"src":require('../../pages/page-one/img/p1-c3-p5.jpg')},{"src":require('../../pages/page-one/img/p4-c1-p1.jpg')},{"src":require('../../pages/page-one/img/p4-c1-p2.jpg')},{"src":require('../../pages/page-one/img/p4-c1-p3.jpg')},{"src":require('../../pages/page-one/img/p4-c1-p4.jpg')},{"src":require('../../pages/page-one/img/p4-c1-p5.jpg')},{"src":require('../../pages/page-one/img/p4-c2-p1.jpg')},{"src":require('../../pages/page-one/img/p4-c2-p2.jpg')},{"src":require('../../pages/page-one/img/p4-c2-p3.jpg')},{"src":require('../../pages/page-one/img/p4-c2-p4.jpg')},{"src":require('../../pages/page-one/img/pg1-bottom-bg.png')},{"src":require('../../pages/page-one/img/planet1.png')},{"src":require('../../pages/page-one/img/planet2.png')},{"src":require('../../pages/page-one/img/planet3.png')},{"src":require('../../pages/page-one/img/planet4.png')},{"src":require('../../pages/page-one/img/po-article.png')},{"src":require('../../pages/page-one/img/po-article2-bg.png')},{"src":require('../../pages/page-one/img/po-article2-c1.png')},{"src":require('../../pages/page-one/img/po-article2-c2.png')},{"src":require('../../pages/page-one/img/po-bg-bottom.png')},{"src":require('../../pages/page-one/img/po-bg-top.png')},{"src":require('../../pages/page-one/img/po-title-sub-inner.png')},{"src":require('../../pages/page-one/img/po-title-sub.png')},{"src":require('../../pages/page-one/img/po-title.png')},{"src":require('../../pages/page-one/img/title.png')},{"src":require('../../pages/page-three/img/film-wp-part.png')},{"src":require('../../pages/page-three/img/pg3-article-bg.png')},{"src":require('../../pages/page-three/img/pg3-article-title1-inner.png')},{"src":require('../../pages/page-three/img/pg3-article-title2-inner.png')},{"src":require('../../pages/page-three/img/pg3-article-title3-inner.png')},{"src":require('../../pages/page-three/img/pg3-article2.png')},{"src":require('../../pages/page-three/img/pg3-article3-bg.png')},{"src":require('../../pages/page-three/img/pg3-article3-c1.png')},{"src":require('../../pages/page-three/img/pg3-article3-c2.png')},{"src":require('../../pages/page-three/img/pg3-article3-c3.png')},{"src":require('../../pages/page-three/img/pg3-article3-c4.png')},{"src":require('../../pages/page-three/img/pg3-film.jpg')},{"src":require('../../pages/page-three/img/pg3-title.png')},{"src":require('../../pages/page-two/img/p2-bottom-bg.png')},{"src":require('../../pages/page-two/img/pg2-article1.png')},{"src":require('../../pages/page-two/img/pg2-article2.png')},{"src":require('../../pages/page-two/img/pg2-article3-bg.png')},{"src":require('../../pages/page-two/img/pg2-article3-c1.png')},{"src":require('../../pages/page-two/img/pg2-table-part1-txt.png')},{"src":require('../../pages/page-two/img/pg2-table-part1.png')},{"src":require('../../pages/page-two/img/pg2-table-part2-txt.png')},{"src":require('../../pages/page-two/img/pg2-table-part2.png')},{"src":require('../../pages/page-two/img/pg2-table-part3-txt.png')},{"src":require('../../pages/page-two/img/pg2-table-part3.png')},{"src":require('../../pages/page-two/img/pg2-thumb.png')},{"src":require('../../pages/page-two/img/pg2-title-sub-inner.png')},{"src":require('../../pages/page-two/img/pg2-title-sub2-inner.png')},{"src":require('../../pages/page-two/img/pg2-title.png')},{"src":require('../../pages/page-two/img/title2.png')},{"src":require('../../components/musicplayer/img/music-off.png')},{"src":require('../../components/musicplayer/img/music-on.png')},{"src":require('../../components/navBar/img/icon1-a.png')},{"src":require('../../components/navBar/img/icon1.png')},{"src":require('../../components/navBar/img/icon2-a.png')},{"src":require('../../components/navBar/img/icon2.png')},{"src":require('../../components/navBar/img/icon3-a.png')},{"src":require('../../components/navBar/img/icon3.png')},{"src":require('../../components/navBar/img/icon4-a.png')},{"src":require('../../components/navBar/img/icon4.png')},{"src":require('../../components/navBar/img/icon5-a.png')},{"src":require('../../components/navBar/img/icon5.png')},{"src":require('../../components/navBar/img/nav.png')},{"src":require('../../components/navBar/img/person.png')},{"src":require('../../components/rotate/img/rt-direction.png')},{"src":require('../../components/rotate/img/rt-fail.png')},{"src":require('../../components/rotate/img/rt-success.png')},{"src":require('../../components/vd-player/img/play.png')}]
    }
  },
  methods: {
    generateId (index) {
      return 'mImg' + index
    },
    go () {
      this.$emit('nextPage', 'isKVShow')
    },
    loadNextImg(imgID){
      const _this = this
      const len = this.preLoadImg.length
      const curSrc = this.preLoadImg[imgID].src
      let curImg = new Image()
      curImg.onload = function () {
        imgID++
        _this.loadingNum = parseInt(imgID / len * 100)
        if (imgID < len) {
          _this.loadNextImg(imgID)
        } else {
          _this.isShow.isKVShow = true;
          _this.isAni = true;
          setTimeout(() => {
            _this.isShow.isLDShow = false;
          }, 1500)
        }
      }
      curImg.src = curSrc
    }
  },
  mounted () {
    let imgID = 0
    setTimeout(() => {
      this.loadNextImg(imgID)
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url('./img/ld-bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  transform-origin: 50% 50%;
  z-index: 2;
  transition: all .2s;
}
.loading-ani {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  animation: scalePage 1.2s ease-out .2s;
  animation-fill-mode: both;
}
.ld-animation {
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: scale(0.5) translateY(4rem);
}
.ld-person {
  width: 130px;
  height: 176px;
  margin-bottom: .1rem;
  background-repeat: no-repeat;
  background-image: url('./img/ld-person.png');
  animation: run 1s steps(8) infinite;
}
.progress-bar-wp {
  margin-bottom: 14rem;
}
.progress-bar {
  box-sizing: border-box;
  height: .625rem /* 10/16 */;
  width: 28.125/2rem /* 450/16 */;
  border: 1px solid #ffe3e8;
  border-radius: .375rem /* 6/16 */;
  padding: .125rem /* 2/16 */;
  margin: 2rem /* 32/16 */ 0;
}
.progress-bar-inner {
  height: 100%;
  background-color: #ffffff;
  border-radius: .25rem /* 4/16 */;
}
.progress-text {
  text-align: center;
  color: #fff;
  font-size: 1rem;
  line-height: 1.4;
}
@keyframes run {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -1040px;
  }
}
@keyframes scaleIt {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(.4);
  }
}
@keyframes scalePage {
  0% {
    // border-radius: 50%;
    transform: scale(1) rotateZ(0);
    height: 100vh;
    border-radius: 1%;
  }
  5% {
    height: 100vw;
    transform: scale(1) rotateZ(0);
    // bottom: 13.5vh;
  }
  20% {
    height: 100vw;
    // bottom: 13.5vh;
  }
  50% {
    border-radius: 50%;
    height: 100vw;
    // bottom: 13.5vh;
  }
  90% {
    border-radius: 50%;
    transform: scale(0.2) rotateZ(1440deg);
    height: 100vw;
    opacity: 1;
    // bottom: 13.5vh;
  }
  100% {
    border-radius: 50%;
    transform: scale(0.2) rotateZ(1440deg);
    height: 100vw;
    opacity: 0;
    // bottom: 13.5vh;
  }
}
</style>
